/**
 * Affiliate Reducers
 * ==================
 *
 * Redux reducers for the manual affiliate system
 */

import {
    // Affiliate Assignment
    GET_PLAYER_AFFILIATES_REQUEST,
    GET_PLAYER_AFFILIATES_SUCCESS,
    GET_PLAYER_AFFILIATES_FAIL,
    GET_PLAYER_AFFILIATES_RESET,
    ASSIGN_AFFILIATE_REQUEST,
    ASSIGN_AFFILIATE_SUCCESS,
    ASSIGN_AFFILIATE_FAIL,
    ASSIGN_AFFILIATE_RESET,
    UPDATE_AFFILIATE_ASSIGNMENT_REQUEST,
    UPDATE_AFFILIATE_ASSIGNMENT_SUCCESS,
    UPDATE_AFFILIATE_ASSIGNMENT_FAIL,
    UPDATE_AFFILIATE_ASSIGNMENT_RESET,
    REMOVE_AFFILIATE_ASSIGNMENT_REQUEST,
    REMOVE_AFFILIATE_ASSIGNMENT_SUCCESS,
    REMOVE_AFFILIATE_ASSIGNMENT_FAIL,
    REMOVE_AFFILIATE_ASSIGNMENT_RESET,
    GET_AFFILIATE_REFERRALS_REQUEST,
    GET_AFFILIATE_REFERRALS_SUCCESS,
    GET_AFFILIATE_REFERRALS_FAIL,
    GET_AFFILIATE_REFERRALS_RESET,

    // Session Hours
    LOG_SESSION_HOURS_REQUEST,
    LOG_SESSION_HOURS_SUCCESS,
    LOG_SESSION_HOURS_FAIL,
    LOG_SESSION_HOURS_RESET,
    GET_PLAYER_SESSION_HOURS_REQUEST,
    GET_PLAYER_SESSION_HOURS_SUCCESS,
    GET_PLAYER_SESSION_HOURS_FAIL,
    GET_PLAYER_SESSION_HOURS_RESET,
    VOID_SESSION_LOG_REQUEST,
    VOID_SESSION_LOG_SUCCESS,
    VOID_SESSION_LOG_FAIL,
    VOID_SESSION_LOG_RESET,

    // Commission Tiers
    GET_COMMISSION_TIERS_REQUEST,
    GET_COMMISSION_TIERS_SUCCESS,
    GET_COMMISSION_TIERS_FAIL,
    GET_COMMISSION_TIERS_RESET,
    CREATE_COMMISSION_TIER_REQUEST,
    CREATE_COMMISSION_TIER_SUCCESS,
    CREATE_COMMISSION_TIER_FAIL,
    CREATE_COMMISSION_TIER_RESET,
    UPDATE_COMMISSION_TIER_REQUEST,
    UPDATE_COMMISSION_TIER_SUCCESS,
    UPDATE_COMMISSION_TIER_FAIL,
    UPDATE_COMMISSION_TIER_RESET,
    DELETE_COMMISSION_TIER_REQUEST,
    DELETE_COMMISSION_TIER_SUCCESS,
    DELETE_COMMISSION_TIER_FAIL,
    DELETE_COMMISSION_TIER_RESET,
    SEED_DEFAULT_TIERS_REQUEST,
    SEED_DEFAULT_TIERS_SUCCESS,
    SEED_DEFAULT_TIERS_FAIL,
    SEED_DEFAULT_TIERS_RESET,

    // Commission Calculation
    PREVIEW_COMMISSION_REQUEST,
    PREVIEW_COMMISSION_SUCCESS,
    PREVIEW_COMMISSION_FAIL,
    PREVIEW_COMMISSION_RESET,
    CALCULATE_COMMISSION_REQUEST,
    CALCULATE_COMMISSION_SUCCESS,
    CALCULATE_COMMISSION_FAIL,
    CALCULATE_COMMISSION_RESET,
    GET_PENDING_COMMISSIONS_REQUEST,
    GET_PENDING_COMMISSIONS_SUCCESS,
    GET_PENDING_COMMISSIONS_FAIL,
    GET_PENDING_COMMISSIONS_RESET,
    APPROVE_COMMISSION_REQUEST,
    APPROVE_COMMISSION_SUCCESS,
    APPROVE_COMMISSION_FAIL,
    APPROVE_COMMISSION_RESET,
    REJECT_COMMISSION_REQUEST,
    REJECT_COMMISSION_SUCCESS,
    REJECT_COMMISSION_FAIL,
    REJECT_COMMISSION_RESET,
    BULK_APPROVE_COMMISSIONS_REQUEST,
    BULK_APPROVE_COMMISSIONS_SUCCESS,
    BULK_APPROVE_COMMISSIONS_FAIL,
    BULK_APPROVE_COMMISSIONS_RESET,

    // Potential Affiliates
    GET_POTENTIAL_AFFILIATES_REQUEST,
    GET_POTENTIAL_AFFILIATES_SUCCESS,
    GET_POTENTIAL_AFFILIATES_FAIL,
    GET_POTENTIAL_AFFILIATES_RESET,
} from '../constants/affiliateConstants';

// ============================================================================
// AFFILIATE ASSIGNMENT REDUCERS
// ============================================================================

export const playerAffiliatesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PLAYER_AFFILIATES_REQUEST:
            return { loading: true };
        case GET_PLAYER_AFFILIATES_SUCCESS:
            return {
                loading: false,
                assignments: action.payload.assignments,
                totalSplit: action.payload.totalSplit,
                remainingAllowed: action.payload.remainingAllowed
            };
        case GET_PLAYER_AFFILIATES_FAIL:
            return { loading: false, error: action.payload };
        case GET_PLAYER_AFFILIATES_RESET:
            return {};
        default:
            return state;
    }
};

export const assignAffiliateReducer = (state = {}, action) => {
    switch (action.type) {
        case ASSIGN_AFFILIATE_REQUEST:
            return { loading: true };
        case ASSIGN_AFFILIATE_SUCCESS:
            return { loading: false, success: true, assignment: action.payload.assignment };
        case ASSIGN_AFFILIATE_FAIL:
            return { loading: false, error: action.payload };
        case ASSIGN_AFFILIATE_RESET:
            return {};
        default:
            return state;
    }
};

export const updateAffiliateAssignmentReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_AFFILIATE_ASSIGNMENT_REQUEST:
            return { loading: true };
        case UPDATE_AFFILIATE_ASSIGNMENT_SUCCESS:
            return { loading: false, success: true, assignment: action.payload.assignment };
        case UPDATE_AFFILIATE_ASSIGNMENT_FAIL:
            return { loading: false, error: action.payload };
        case UPDATE_AFFILIATE_ASSIGNMENT_RESET:
            return {};
        default:
            return state;
    }
};

export const removeAffiliateAssignmentReducer = (state = {}, action) => {
    switch (action.type) {
        case REMOVE_AFFILIATE_ASSIGNMENT_REQUEST:
            return { loading: true };
        case REMOVE_AFFILIATE_ASSIGNMENT_SUCCESS:
            return { loading: false, success: true };
        case REMOVE_AFFILIATE_ASSIGNMENT_FAIL:
            return { loading: false, error: action.payload };
        case REMOVE_AFFILIATE_ASSIGNMENT_RESET:
            return {};
        default:
            return state;
    }
};

export const affiliateReferralsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_AFFILIATE_REFERRALS_REQUEST:
            return { loading: true };
        case GET_AFFILIATE_REFERRALS_SUCCESS:
            return { loading: false, referrals: action.payload.referrals, count: action.payload.count };
        case GET_AFFILIATE_REFERRALS_FAIL:
            return { loading: false, error: action.payload };
        case GET_AFFILIATE_REFERRALS_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// SESSION HOURS REDUCERS
// ============================================================================

export const logSessionHoursReducer = (state = {}, action) => {
    switch (action.type) {
        case LOG_SESSION_HOURS_REQUEST:
            return { loading: true };
        case LOG_SESSION_HOURS_SUCCESS:
            return { loading: false, success: true, log: action.payload.log };
        case LOG_SESSION_HOURS_FAIL:
            return { loading: false, error: action.payload };
        case LOG_SESSION_HOURS_RESET:
            return {};
        default:
            return state;
    }
};

export const playerSessionHoursReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PLAYER_SESSION_HOURS_REQUEST:
            return { loading: true };
        case GET_PLAYER_SESSION_HOURS_SUCCESS:
            return {
                loading: false,
                manualHours: action.payload.manualHours,
                automaticHours: action.payload.automaticHours,
                period: action.payload.period
            };
        case GET_PLAYER_SESSION_HOURS_FAIL:
            return { loading: false, error: action.payload };
        case GET_PLAYER_SESSION_HOURS_RESET:
            return {};
        default:
            return state;
    }
};

export const voidSessionLogReducer = (state = {}, action) => {
    switch (action.type) {
        case VOID_SESSION_LOG_REQUEST:
            return { loading: true };
        case VOID_SESSION_LOG_SUCCESS:
            return { loading: false, success: true };
        case VOID_SESSION_LOG_FAIL:
            return { loading: false, error: action.payload };
        case VOID_SESSION_LOG_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// COMMISSION TIER REDUCERS
// ============================================================================

export const commissionTiersReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_COMMISSION_TIERS_REQUEST:
            return { loading: true };
        case GET_COMMISSION_TIERS_SUCCESS:
            return { loading: false, tiers: action.payload.tiers };
        case GET_COMMISSION_TIERS_FAIL:
            return { loading: false, error: action.payload };
        case GET_COMMISSION_TIERS_RESET:
            return {};
        default:
            return state;
    }
};

export const createCommissionTierReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_COMMISSION_TIER_REQUEST:
            return { loading: true };
        case CREATE_COMMISSION_TIER_SUCCESS:
            return { loading: false, success: true, tier: action.payload.tier };
        case CREATE_COMMISSION_TIER_FAIL:
            return { loading: false, error: action.payload };
        case CREATE_COMMISSION_TIER_RESET:
            return {};
        default:
            return state;
    }
};

export const updateCommissionTierReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_COMMISSION_TIER_REQUEST:
            return { loading: true };
        case UPDATE_COMMISSION_TIER_SUCCESS:
            return { loading: false, success: true, tier: action.payload.tier };
        case UPDATE_COMMISSION_TIER_FAIL:
            return { loading: false, error: action.payload };
        case UPDATE_COMMISSION_TIER_RESET:
            return {};
        default:
            return state;
    }
};

export const deleteCommissionTierReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_COMMISSION_TIER_REQUEST:
            return { loading: true };
        case DELETE_COMMISSION_TIER_SUCCESS:
            return { loading: false, success: true };
        case DELETE_COMMISSION_TIER_FAIL:
            return { loading: false, error: action.payload };
        case DELETE_COMMISSION_TIER_RESET:
            return {};
        default:
            return state;
    }
};

export const seedDefaultTiersReducer = (state = {}, action) => {
    switch (action.type) {
        case SEED_DEFAULT_TIERS_REQUEST:
            return { loading: true };
        case SEED_DEFAULT_TIERS_SUCCESS:
            return { loading: false, success: true, result: action.payload };
        case SEED_DEFAULT_TIERS_FAIL:
            return { loading: false, error: action.payload };
        case SEED_DEFAULT_TIERS_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// COMMISSION CALCULATION REDUCERS
// ============================================================================

export const commissionPreviewReducer = (state = {}, action) => {
    switch (action.type) {
        case PREVIEW_COMMISSION_REQUEST:
            return { loading: true };
        case PREVIEW_COMMISSION_SUCCESS:
            return {
                loading: false,
                period: action.payload.period,
                calculations: action.payload.calculations,
                grandTotal: action.payload.grandTotal,
                affiliateCount: action.payload.affiliateCount
            };
        case PREVIEW_COMMISSION_FAIL:
            return { loading: false, error: action.payload };
        case PREVIEW_COMMISSION_RESET:
            return {};
        default:
            return state;
    }
};

export const calculateCommissionReducer = (state = {}, action) => {
    switch (action.type) {
        case CALCULATE_COMMISSION_REQUEST:
            return { loading: true };
        case CALCULATE_COMMISSION_SUCCESS:
            return {
                loading: false,
                success: true,
                created: action.payload.created,
                errors: action.payload.errors
            };
        case CALCULATE_COMMISSION_FAIL:
            return { loading: false, error: action.payload };
        case CALCULATE_COMMISSION_RESET:
            return {};
        default:
            return state;
    }
};

export const pendingCommissionsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PENDING_COMMISSIONS_REQUEST:
            return { loading: true };
        case GET_PENDING_COMMISSIONS_SUCCESS:
            return {
                loading: false,
                commissions: action.payload.commissions,
                summary: action.payload.summary,
                totalCount: action.payload.totalCount,
                grandTotal: action.payload.grandTotal
            };
        case GET_PENDING_COMMISSIONS_FAIL:
            return { loading: false, error: action.payload };
        case GET_PENDING_COMMISSIONS_RESET:
            return {};
        default:
            return state;
    }
};

export const approveCommissionReducer = (state = {}, action) => {
    switch (action.type) {
        case APPROVE_COMMISSION_REQUEST:
            return { loading: true };
        case APPROVE_COMMISSION_SUCCESS:
            return { loading: false, success: true, commission: action.payload.commission };
        case APPROVE_COMMISSION_FAIL:
            return { loading: false, error: action.payload };
        case APPROVE_COMMISSION_RESET:
            return {};
        default:
            return state;
    }
};

export const rejectCommissionReducer = (state = {}, action) => {
    switch (action.type) {
        case REJECT_COMMISSION_REQUEST:
            return { loading: true };
        case REJECT_COMMISSION_SUCCESS:
            return { loading: false, success: true };
        case REJECT_COMMISSION_FAIL:
            return { loading: false, error: action.payload };
        case REJECT_COMMISSION_RESET:
            return {};
        default:
            return state;
    }
};

export const bulkApproveCommissionsReducer = (state = {}, action) => {
    switch (action.type) {
        case BULK_APPROVE_COMMISSIONS_REQUEST:
            return { loading: true };
        case BULK_APPROVE_COMMISSIONS_SUCCESS:
            return { loading: false, success: true, results: action.payload.results };
        case BULK_APPROVE_COMMISSIONS_FAIL:
            return { loading: false, error: action.payload };
        case BULK_APPROVE_COMMISSIONS_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// POTENTIAL AFFILIATES REDUCER
// ============================================================================

export const potentialAffiliatesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_POTENTIAL_AFFILIATES_REQUEST:
            return { loading: true };
        case GET_POTENTIAL_AFFILIATES_SUCCESS:
            return { loading: false, affiliates: action.payload.affiliates };
        case GET_POTENTIAL_AFFILIATES_FAIL:
            return { loading: false, error: action.payload };
        case GET_POTENTIAL_AFFILIATES_RESET:
            return {};
        default:
            return state;
    }
};
